<template>
  <header id="m_header" class="m-grid__item    m-header " m-minimize-offset="200" m-minimize-mobile-offset="200"
          v-click-outside="closeDropdowns">
    <div class="m-container m-container--responsive m-container--xxl m-container--full-height">
      <div class="m-stack m-stack--ver m-stack--desktop">
        <!-- BEGIN: Brand -->
        <div class="m-stack__item m-brand  m-brand--skin-light flex-center">
          <div class="m-stack m-stack--ver m-stack--general d-lg-flex w-90">
            <div class="m-stack__item m-stack__item--middle m-brand__logo logo-center pt-2" v-if="logoUrl">
              <a href="#" @click="pushToFirstPage" class="m-brand__logo-wrapper">
                <div>
                  <img :alt="title" :src="logoUrl" class="logo"/>
                </div>
              </a>
            </div>
            <div class="module-title-container" v-else>
              <div class="module-title">
                <span class="title font-ls" v-encode="title"></span>
              </div>
            </div>

            <div class="m-stack__item m-stack__item--middle m-info__tools m--hidden-desktop">

              <!-- BEGIN: Topbar Toggler -->
              <div>
                <a @click="toggleUserProfileDropdown"
                   class="m-info__icon m--visible-tablet-and-mobile-inline-block pull-right">
                <span class="m-topbar__userpic">
                  <img src="@/assets/app/media/img/users/user_icon.png" height="30"
                       class="m--img-rounded m--marginless"/>
                </span>
                </a>
              </div>

              <!-- BEGIN: Topbar Toggler -->

              <div v-if="navigationPages.length">
                <a class="hamburger m-info__icon m--visible-tablet-and-mobile-inline-block pull-right hamburger-ls"
                   @click="toggleMenuDropdown">
                  <i class="fa fa-bars font-size-20"></i>
                </a>
              </div>

              <div v-if="isMyCardEnabled" @click="closeDropdowns">
                <a class="hamburger m-info__icon m--visible-tablet-and-mobile-inline-block pull-right hamburger-ls"
                   v-b-modal.barcode>
                  <i class="fa fa-credit-card fa-rotate-180 font-size-18"></i>
                </a>
              </div>

            </div>
          </div>
        </div>
        <!-- END: Brand -->
        <div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
          <!-- BEGIN: Topbar -->
          <div id="m_header_topbar" class="m-topbar  m-stack m-stack--ver m-stack--general m-stack--fluid">
            <div class="m-stack__item m-topbar__nav-wrapper">
              <ul class="m-topbar__nav m-nav m-nav--inline">
                <li class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
                    :class="{ 'm-dropdown--open': isUserProfileDropdownOpen }">
                  <a href="#" class="m-nav__link m-dropdown__toggle" @click="toggleUserProfileDropdown"
                     @mouseover="openUserProfileDropdown">
                    <span class="m-topbar__userpic">
                      <img src="@/assets/app/media/img/users/user_icon.png" class="m--img-rounded m--marginless"/>
                    </span>
                  </a>
                  <div class="m-dropdown__wrapper m-dropdown__wrapper-profile">
                    <div class="m-dropdown__inner">
                      <div class="m-dropdown__body dropdown-scrollable">
                        <client class="m--hidden-desktop"></client>
                        <div class="m-dropdown__content">
                          <ul class="m-nav m-nav--skin-light">
                            <li class="m-nav__section m--hide">
                              <span class="m-nav__section-text">Section</span>
                            </li>
                            <li class="m-nav__item m-nav__item-ls" @click="closeDropdowns">
                              <router-link :to="{name: 'ProfilePage'}" class="m-nav__link">
                                <i class="m-nav__link-icon fa fa-user-cog"></i>
                                <span class="m-nav__link-title">
                                  <span class="m-nav__link-wrap">
                                    <span class="m-nav__link-text">{{ $t('My account') }}</span>
                                  </span>
                                </span>
                              </router-link>
                            </li>
                            <li v-if="isMyCardEnabled" class="m-nav__item m-nav__item-ls" @click="closeDropdowns">
                              <a class="m-nav__link cursor-pointer" v-b-modal.barcode>
                                <span class="m-nav__link-icon">
                                  <i class="fa fa-credit-card fa-rotate-180"></i>
                                </span>
                                <span class="m-nav__link-title">
                                  <span class="m-nav__link-wrap">
                                    <span class="m-nav__link-text">{{ $t('Member Card') }}</span>
                                  </span>
                                </span>
                              </a>
                            </li>
                            <li v-if="agreements.length || isSelfRegistered" class="m-nav__item m-nav__item-ls"
                                @click="closeDropdowns">
                              <router-link :to="{name: 'AgreementsPage'}" class="m-nav__link">
                                <i class="m-nav__link-icon fa fa-handshake"></i>
                                <span class="m-nav__link-title">
                                  <span class="m-nav__link-wrap">
                                    <span class="m-nav__link-text">{{ $t('My agreements') }}</span>
                                  </span>
                                </span>
                              </router-link>
                            </li>
                            <li v-if="attachmentsEnabled" class="m-nav__item m-nav__item-ls"
                                @click="closeDropdowns">
                              <router-link :to="{name: 'AttachmentsPage'}" class="m-nav__link">
                                <i class="m-nav__link-icon fa fa-paperclip"></i>
                                <span class="m-nav__link-title">
                                  <span class="m-nav__link-wrap">
                                    <span class="m-nav__link-text">{{ $t('My attachments') }}</span>
                                  </span>
                                </span>
                              </router-link>
                            </li>
                            <li class="m-nav__item m-nav__item-ls" @click="closeDropdowns">
                              <router-link :to="{name: 'ChangePassword'}" class="m-nav__link">
                                <i class="m-nav__link-icon fa fa-key"></i>
                                <span class="m-nav__link-title">
                                  <span class="m-nav__link-wrap">
                                    <span class="m-nav__link-text">{{ changePasswordPageTitle }}</span>
                                  </span>
                                </span>
                              </router-link>
                            </li>
                            <li v-if="isProfileEditEnabled" class="m-nav__item m-nav__item-ls"
                                @click="closeDropdowns">
                              <router-link :to="{name: 'ChangeEmail'}" class="m-nav__link">
                                <i class="m-nav__link-icon fa fa-envelope"></i>
                                <span class="m-nav__link-title">
                                  <span class="m-nav__link-wrap">
                                    <span class="m-nav__link-text">{{ $t('Change email') }}</span>
                                  </span>
                                </span>
                              </router-link>
                            </li>
                            <li v-if="canInstallPwa && mobileApplication" class="m-nav__item m-nav__item-ls" @click="closeDropdowns">
                              <a href="#" class="m-nav__link" @click="$bvModal.show('install-pwa-modal')">
                                <i class="m-nav__link-icon fa fa-tablet-alt"></i>
                                <span class="m-nav__link-title">
                                  <span class="m-nav__link-wrap">
                                    <span class="m-nav__link-text">{{ $t('Install app') }}</span>
                                  </span>
                                </span>
                              </a>
                            </li>
                            <li class="m-nav__separator m-nav__separator--fit">
                            </li>
                            <li class="m-nav__item">
                              <a class="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-info m-btn--bolder"
                                 @click="handleLogout">
                                {{ $t('Log out') }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li v-if="navigationPages.length" class="m--hidden-desktop m-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
                    :class="{ 'm-dropdown--open': isMenuDropdownOpen }">
                  <div class="m-dropdown__wrapper">
                    <div class="m-dropdown__inner">
                      <div class="m-dropdown__body dropdown-scrollable">
                        <div class="m-dropdown__content">
                          <ul class="m-nav m-nav--skin-light">
                            <li class="m-nav__section m--hide">
                              <span class="m-nav__section-text">Section</span>
                            </li>
                            <li v-for="(page, i) in navigationPages" :key="i" class="m-nav__item m-nav__item-ls"
                                @click="closeDropdowns">
                              <router-link :to="page.to"
                                           class="m-nav__link">
                                <i class="m-nav__link-icon" :class="page.icon"></i>
                                <span class="m-nav__link-title">
                                  <span class="m-nav__link-wrap w-auto">
                                    <span class="m-nav__link-text w-auto" v-encode="page.title"></span>
                                    <span v-if="page.to.name === 'MessagesPage' && unreadMessages"
                                          class="m-badge m-badge--ls">{{unreadMessages}}</span>
                                  </span>
                                </span>
                              </router-link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <barcode></barcode>
  </header>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import {mapActions, mapState} from 'vuex'
import Client from "../sidebar/Client";
import Encode from "@/directives/encode";
import Barcode from "../barcode/Barcode";

export default {
  name: "Header",
  components: {Barcode, Client},
  data() {
    return {
      isUserProfileDropdownOpen: false,
      isMenuDropdownOpen: false
    }
  },
  methods: {
    toggleUserProfileDropdown() {
      this.isUserProfileDropdownOpen = !this.isUserProfileDropdownOpen;
      this.isMenuDropdownOpen = false;
    },
    openUserProfileDropdown() {
      this.isUserProfileDropdownOpen = true;
      this.isMenuDropdownOpen = false;
    },
    closeDropdowns() {
      this.isUserProfileDropdownOpen = false;
      this.isMenuDropdownOpen = false;
    },

    toggleMenuDropdown() {
      this.isMenuDropdownOpen = !this.isMenuDropdownOpen;
      this.isUserProfileDropdownOpen = false;
    },
    openMenuDropdown() {
      this.isMenuDropdownOpen = true;
      this.isUserProfileDropdownOpen = false;
    },
    handleLogout() {
      this.$http.post('/logout');
      this.logout();
    },
    ...mapActions([
      'logout',
      'pushToFirstPage'
    ])
  },
  directives: {
    ClickOutside,
    Encode
  },
  computed: {
    ...mapState({
      entityUuid: state => state.auth.entity.uuid,
      logoUrl: state => state.settings.logoUrl,
      title: state => state.settings.title,
      isProfileEditEnabled: state => state.settings.disableProfileEdit === '0',
      agreements: state => state.auth.agreements,
      isMyCardEnabled: state => state.settings.myCardEnabled === '1',
      isSelfRegistered: state => state.auth.user.self_registered,
      attachmentsEnabled: state => state.settings.attachments.enabled,
      setPassword: state => state.auth.user.set_password,
      navigationPages: state => state.navigation.pages,
      isPwa: state => state.browser.isPwa,
      canInstallPwa: state => state.browser.canInstallPwa,
      bowser: state => state.browser,
      unreadMessages: state => state.auth.user.unread_messages,
      isAuthorized: state => state.auth.isAuthorized,
      push: state => state.settings.push,
      mobileApplication: state => state.settings.mobileApplication,
      translation: state => state.translation,
    }),
    changePasswordPageTitle() {
      return this.setPassword ? this.$t('Set password') : this.$t('Change Password');
    },
    pushTokenExistsStorageKey() {
      return `ls-push-token-${this.entityUuid}`;
    },
  }
}
</script>

<style scoped>
.logo {
  max-width: 200px;
}

@media (max-width: 1025px) {
  .logo {
    max-height: 50px;
  }
}

@media (min-width: 1025px) {
  .logo {
    /*width: 200px;*/
    max-height: 60px;
  }
}

.dropdown-scrollable {
  max-height: 83vh;
  overflow-y: auto;
}

.m-brand {
  padding: 0 20px !important;
}

.hamburger {
  padding-right: 20px;
  margin-top: 5px;
}

.font-size-20 {
  font-size: 20px;
}

.font-size-18 {
  font-size: 18px;
}

.flex-center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.module-title {
  width: 200px;
  height: 100%;
  display: flex;
}

.module-title-container {
  height: 100%;
  width: 255px;
  display: flex;
  align-items: center;
  word-wrap: break-word;
}

.title {
  font-weight: 500;
  font-size: 1.5rem;
  font-family: inherit;
  margin: auto;
}

@media (max-width: 468px) {
  .title {
    font-size: 4vw;
  }
}

@media (max-width: 1000px) {
  .title {
    margin: auto auto auto 0;
  }
}

@media (min-width: 1026px) {
  @supports (-moz-appearance:none) {
    .module-title-container {
      display: block !important;
    }
  }
}

@media (min-width: 769px) {
  .m-dropdown__wrapper.m-dropdown__wrapper-profile {
    width: 200px;
  }
}

@media (min-width: 1025px) {
  .m-dropdown__wrapper.m-dropdown__wrapper-profile {
    width: 200px !important;
  }
}

.m-nav .m-nav__item .m-nav__item-ls:hover:not(.m-nav__item--disabled) > .m-nav__link .m-nav__link-text,
.m-nav .m-nav__item .m-nav__item-ls:hover:not(.m-nav__item--disabled) > .m-nav__link .m-nav__link-icon,
.hamburger-ls {
  color: var(--accent-color) !important;
}

.m-nav__link-icon .fa {
  font-size: 1.4rem;
}

.m-widget1 {
  padding: unset;
}

.cursor-pointer {
  cursor: pointer;
}

.logo-center {
  text-align: center;
  margin: auto;
}

@media (max-width: 1024px) {
  .logo-center {
    text-align: unset;
  }
}

.m-badge {
  font-weight: 500;
}

.w-90 {
  width: 90vw;
}
</style>
